import * as api from "api/endpoints/app";
import { createSlice, createSliceSelector } from "../factory";

const name = "administrationPage";

const initialState = {
  apiKey: {}
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectApiKey = createSelector((state) => {
  return state.apiKey;
});

/* Actions */
const { update } = slice.actions;

export function loadApiKeys(epId) {
  const config = { params: { epId: epId } };
  return async function (dispatch) {
    api
      .getApiKey(config)
      .then((res) => {
        const payload = { apiKey: res.details };
        dispatch(update(payload));
      })
      .catch((err) => {
        const payload = { apiKey: null };
        dispatch(update(payload));
      });
  };
}
